import Vuex from 'vuex'
import flash from './modules/flash'
import globalErrors from './modules/globalErrors'
import options from './modules/options'
import tutorial from './modules/tutorial'
import tooltips from './modules/tooltips'
import loading from './modules/loading'
import recaptcha from './modules/recaptcha'


const store = new Vuex.Store({
	state: {
		...tutorial.state,
		...flash.state,
		...globalErrors.state,
		...options.state,
		...tooltips.state,
		...loading.state,
		...recaptcha.state
	},
	getters: {
		...options.getters,
		...tutorial.getters,
		...tooltips.getters,
		...loading.getters,
		...recaptcha.getters
	},
	mutations: {
		...tutorial.mutations,
		...flash.mutations,
		...globalErrors.mutations,
		...options.mutations,
		...tooltips.mutations,
		...loading.mutations,
		...recaptcha.mutations
	},
	actions: {
		...tutorial.actions,
		...flash.actions,
		...globalErrors.actions,
		...options.actions,
		...tooltips.actions,
		...loading.actions,
		...recaptcha.actions
	}
})

export default store
